// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gc9X","textarea":"styles_textarea__Hrrhv"};